import { pxToREM } from './utils'

export const uiFontSizes = {
  ui_08: pxToREM({ px: 8 }),
  ui_10: pxToREM({ px: 10 }),
  ui_12: pxToREM({ px: 12 }),
  ui_14: pxToREM({ px: 14 })
}
